import { useState } from "react";
import SiteAdminScheduleInspector from "@/components/SiteAdminScheduleInspector";

/**
 * iter86.31.7 — Rivalry Schedule Inspector (Site Admin → Admin Ops →
 * Templates), relocated from the retired Template Presets editor.
 * Pick a template type → pick a rivalry using it → view schedule info,
 * resync from feed (cache), or god-mode a match score.
 */
const TEMPLATE_OPTIONS = [
    ["world_cup_api", "Soccer Tournament — World Cup"],
    ["world_cup_ko_api", "Soccer KO — World Cup"],
    ["premier_league_api", "Soccer Season — Premier League"],
    ["la_liga_api", "Soccer Season — La Liga"],
    ["champions_league_api", "Soccer Season — Champions League"],
    ["club_season_api", "Soccer Season — Dynamic league (bindings)"],
    ["golf_pickem_lowest_avg_api", "Golf — Lowest Average"],
    ["golf_position_draft_api", "Golf — Position Draft"],
    ["march_madness", "Basketball KO — March Madness"],
    ["world_cup", "Legacy — World Cup (ESPN)"],
    ["world_cup_knockout", "Legacy — WC Knockout (ESPN)"],
    ["custom", "Custom"],
];

export default function TemplateScheduleInspectorCard() {
    const [templateKey, setTemplateKey] = useState("");

    return (
        <div className="brutal-card p-4 space-y-3" data-testid="template-schedule-inspector-card">
            <div>
                <h3 className="font-display font-extrabold text-sm uppercase">Rivalry Schedule Inspector</h3>
                <p className="text-[11px] text-zinc-500 mt-0.5">
                    Diagnose + repair a live rivalry's schedule: pick the template type, then the
                    rivalry — view its schedule, resync from the cached feed, or override a score.
                </p>
            </div>
            <select
                data-testid="inspector-template-select"
                value={templateKey}
                onChange={(e) => setTemplateKey(e.target.value)}
                className="brutal-input text-xs max-w-[320px]"
            >
                <option value="">— pick a template type —</option>
                {TEMPLATE_OPTIONS.map(([k, label]) => (
                    <option key={k} value={k}>{label}</option>
                ))}
            </select>
            {templateKey && <SiteAdminScheduleInspector key={templateKey} templateKey={templateKey} />}
        </div>
    );
}
